import { Card, CardContent, CardHeader } from '@/components/ui/card';

interface ContactInfoCardProps {
    title: string;
    children: React.ReactNode;
    className?: string;
}

export function ContactInfoCard({ title, children, className = '' }: ContactInfoCardProps) {
    return (
        <Card className={`border border-outline-variant ${className}`}>
            <CardHeader className="p-4">
                <h3 className="font-newsreader text-xl font-semibold tracking-tight tracking-tight text-foreground">
                    {title}
                </h3>
            </CardHeader>
            <CardContent className="space-y-4">
                {children}
            </CardContent>
        </Card>
    );
}
